export default {
  showTitle: (state, article) => {
    return `<a href="${article.body_html}" target="_blank">${article.title} <span>Open</span></a>`;
  }
}